import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import {vuetify} from '@/plugins/vuetify';
import {pinia} from '@/plugins/pinia';
import VueApexCharts from 'vue3-apexcharts'

import {i18n, setLocale} from "@/plugins/i18n";
import {useAuthStore} from "@/modules/authentication/stores/auth";
import { initSentry } from '@/config/sentry';

const app = createApp(App);

app.use(pinia);

const {registerRouting} = useAuthStore();
registerRouting(router);

// Initialize Sentry with proper configuration
initSentry({
  app,
  router,
  dsn: "https://1483638d6c1a0dbb8f399336e8c4623d@sentry.de.healthstudyclub.net/7",
  projectName: 'gateway-backend'
});

app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(VueApexCharts);

app.mount('#app');





